"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyState = void 0;
const react_1 = __importDefault(require("react"));
const noOrders_png_1 = __importDefault(require("assets/images/dashboard/noOrders.png"));
const noSearch_png_1 = __importDefault(require("assets/images/dashboard/noSearch.png"));
const ordersCopy_1 = require("copy/ordersCopy");
const polaris_1 = require("@shopify/polaris");
const EmptyState = ({ hasFilters, loading }) => {
    let header = '';
    let body = '';
    let image;
    switch (true) {
        case hasFilters:
            header = ordersCopy_1.ordersCopy.noOrdersFound;
            body = ordersCopy_1.ordersCopy.noOrdersFoundParagraph;
            image = noSearch_png_1.default;
            break;
        default:
            header = ordersCopy_1.ordersCopy.noOrdersHeader;
            body = ordersCopy_1.ordersCopy.noOrdersParagraph;
            image = noOrders_png_1.default;
            break;
    }
    if (loading) {
        return (react_1.default.createElement(polaris_1.Box, { padding: '800' },
            react_1.default.createElement(polaris_1.BlockStack, { align: 'center', inlineAlign: 'center' },
                react_1.default.createElement(polaris_1.Spinner, { accessibilityLabel: 'Loading', size: 'large' }),
                react_1.default.createElement(polaris_1.Box, { paddingBlockStart: '400' },
                    react_1.default.createElement(polaris_1.Text, { as: 'h1', fontWeight: 'bold', variant: 'headingLg' }, "Loading")))));
    }
    return (react_1.default.createElement(polaris_1.EmptyState, { heading: header, image: image },
        react_1.default.createElement("p", null, body)));
};
exports.EmptyState = EmptyState;
